<template>
  <b-container class="container-rda">
    <b-row class="mb-4 padding-top">
      <b-col>
        <h2 class="purple bold">Indicadores</h2>
      </b-col>
      <b-col class="text-right"></b-col>
    </b-row>
    <b-row class="mb-5">
      <b-col md="4" lg="2">
        <SelectSimple
          v-model="selectedPeriod"
          label="Turno"
          :options="allPeriods"
          :callback="selectPeriod"
        />
      </b-col>
      <b-col md="4" lg="2">
        <SelectSimple
          v-model="selectedSituation"
          label="Situação"
          :options="allSituations"
          :callback="selectSituation"
        />
      </b-col>
    </b-row>
    <b-row class="mb-2">
      <b-col>
        <h5 class="bold">Alunos</h5>
      </b-col>
    </b-row>
    <div v-if="!isLoading">
      <b-row class="mb-5">
        <b-col
          md="4"
          lg="2"
          v-if="dataFromApi.students && dataFromApi.students.actives"
        >
          <div class="indicators-box purple">
            <h5>Ativos</h5>
            <h4>
              {{ dataFromApi.students.actives }}
            </h4>
          </div>
        </b-col>
        <b-col
          md="4"
          lg="2"
          v-if="
            dataFromApi.students && dataFromApi.students.inactivesInCurrentYear
          "
        >
          <div class="indicators-box orange">
            <h5>Inativados este ano</h5>
            <h4>
              {{ dataFromApi.students.inactivesInCurrentYear }}
            </h4>
          </div>
        </b-col>
        <b-col md="4" lg="2" v-if="dataFromApi.evaluations">
          <div class="indicators-box blue">
            <h5>Avaliações</h5>
            <h4>
              {{ dataFromApi.evaluations }}
            </h4>
          </div>
        </b-col>
      </b-row>
      <b-row class="mb-2">
        <b-col>
          <h5 class="bold">Alunos por ciclo</h5>
        </b-col>
      </b-row>
      <b-row
        class="mb-12"
        v-if="
          chartData.datasets[0].data.length > 0 && chartData.labels.length > 0
        "
      >
        <b-col class="box">
          <ui-chart id="myChart" :data="chartData" class="box-chart"></ui-chart>
        </b-col>
      </b-row>
    </div>
    <div
      v-else
      style="
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
      "
    >
      <b-spinner variant="success" label="Carregando..."></b-spinner>
    </div>

    <b-modal
      id="pending-notifications-modal"
      hide-header
      hide-footer
      centered
      no-close-on-backdrop
    >
      <b-row>
        <b-col md="12">
          <div class="pending-modal-title">
            <span class="pending-icon">
              <ExclamationIcon />
            </span>
            <h4 class="purple mb-0">Notificações pendentes</h4>
          </div>
        </b-col>

        <b-col md="12" class="mt-3">
          <p class="pending-message">{{ teacherPendingMessage }}</p>
        </b-col>
      </b-row>

      <b-row class="mt-5">
        <b-col class="text-right">
          <b-button class="btn large blue mr-2" @click="closePendingModal">
            Fechar
          </b-button>
          <b-button class="btn large orange" @click="goToNotificationsInbox">
            Ver notificações
          </b-button>
        </b-col>
      </b-row>
    </b-modal>
  </b-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import UiChart from "../../components/chart/chart.vue";
import httpRda from "../../http-rda";
import SelectSimple from "@/components/inputs/SelectSimple.vue";
import ExclamationIcon from "@/components/svg/Exclamation.vue";

export default {
  name: "Dashbaord",
  components: { UiChart, SelectSimple, ExclamationIcon },
  data() {
    return {
      allPeriods: [
        { id: null, label: "Todos" },
        { id: "Matutino", label: "Matutino" },
        { id: "Vespertino", label: "Vespertino" },
      ],
      selectedPeriod: { id: null, label: "Todos" },
      allSituations: [
        { id: null, label: "Todos" },
        { id: "Veteranos", label: "Veteranos" },
        { id: "Novatos", label: "Novatos" },
      ],
      selectedSituation: { id: null, label: "Todos" },
      isLoading: false,
      dataFromApi: {
        students: null,
        evaluations: null,
      },
      teacherNotificationCounts: { total: 0, unread: 0, solved: 0 },
      breadcrumb: [
        {
          text: "Dashboard",
          href: "/",
        },
      ],
      chartData: {
        labels: [],

        datasets: [
          {
            label: "Por Ciclo",
            backgroundColor: [
              "#b2ecf7",
              "#ffc2c2",
              "#d1e7c0",
              "#d8c7ee",
              "#ffd97d",
              "#ff8b94",
              "#ffd9b6",
              "#b2c9f7",
              "#ffc9ed",
              "#a3e0ce",
              "#ffad76",
              "#e7b3c8",
              "#aedbad",
              "#90a8e6",
              "#e6b890",
              "#c2f7d5",
              "#d1b2ec",
              "#ffd4a2",
              "#a9c0e7",
              "#c7d6f2",
              "#ffb6c7",
              "#d9f0c2",
              "#c7b8e6",
              "#ffdf9d",
            ],
            data: [],
            fill: true,
            borderRadius: 15,
          },
        ],
      },
    };
  },

  filters: {
    //
  },

  computed: {
    ...mapGetters({
      attendances: "shared/studentsAttendances",
      currentUser: "auth/getAuthData",
    }),

    teacherPendingCount() {
      return (
        this.teacherNotificationCounts.total -
        this.teacherNotificationCounts.solved
      );
    },

    teacherPendingMessage() {
      const pending = this.teacherPendingCount;
      const unread = this.teacherNotificationCounts.unread;

      let text = `Você tem ${pending} notificaç${
        pending === 1 ? "ão" : "ões"
      } pendente${pending === 1 ? "" : "s"}.`;
      if (unread > 0) {
        text += ` ${unread} não lida${unread === 1 ? "" : "s"}.`;
      }

      return text;
    },
  },

  methods: {
    ...mapActions({
      getStudentAttendances: "shared/getStudentAttendances",
    }),

    async getChartData() {
      this.isLoading = true;
      const params = {
        time_period:
          this.selectedPeriod && this.selectedPeriod.id
            ? this.selectedPeriod.id
            : undefined,
        student_situation:
          this.selectedSituation && this.selectedSituation.id
            ? this.selectedSituation.id
            : undefined,
      };

      this.chartData.labels = [];
      this.chartData.datasets[0].data = [];

      const response = await httpRda.get("/dashboard", { params });
      this.dataFromApi = response.data.result;

      this.dataFromApi.students.byCycles.forEach((cycle) => {
        this.chartData.labels.push(cycle.cycle_name);
        this.chartData.datasets[0].data.push(+cycle.count);
      });

      this.isLoading = false;
    },

    async selectPeriod(data) {
      this.selectedPeriod = data;
      await this.getChartData();
    },

    async selectSituation(data) {
      this.selectedSituation = data;
      await this.getChartData();
    },

    async fetchTeacherNotificationCounts() {
      const response = await httpRda.get("/teacher/notifications/counts");

      this.teacherNotificationCounts = {
        total: response.data.total,
        unread: response.data.unread,
        solved: response.data.solved,
      };

      if (this.teacherPendingCount > 0) {
        this.$bvModal.show("pending-notifications-modal");
      }
    },

    goToNotificationsInbox() {
      this.$router.push({ name: "professor-notificacoes-inbox" });
    },

    closePendingModal() {
      this.$bvModal.hide("pending-notifications-modal");
    },
  },

  created() {
    this.getChartData();

    if (this.currentUser.role && this.currentUser.role.includes("teacher")) {
      this.fetchTeacherNotificationCounts();
    }
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/variables.scss";

.padding-top {
  padding-top: 40px;
}

.indicators-box {
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 10px;
  border-radius: 10px;

  &.green {
    background-color: #36b67d;
  }
  &.purple {
    background-color: #b23066;
  }
  &.orange {
    background-color: #ef6549;
  }
  &.blue {
    background-color: #49adef;
  }

  h5,
  h4 {
    color: #fff;
    margin: 0;
  }
  h5 {
    font-weight: normal;
    font-size: 14px;
  }
  h4 {
    font-size: 22px;
  }
}

.box-chart {
  width: 100%;
  height: 320px;
  box-sizing: border-box;
}
</style>

<style lang="scss">
@import "@/assets/css/variables.scss";

div#pending-notifications-modal {
  .modal-dialog {
    max-width: 820px;

    .modal-content {
      background-color: $grey2;
      border: 0;
      border-radius: 0;

      .modal-body {
        padding: 60px;
      }
    }
  }

  .pending-modal-title {
    align-items: center;
    display: flex;
    gap: 16px;
  }

  .pending-icon {
    align-items: center;
    background-color: $purple;
    border-radius: 50%;
    display: inline-flex;
    flex-shrink: 0;
    height: 44px;
    justify-content: center;
    width: 44px;

    svg {
      height: 22px;
      width: 22px;
    }

    svg path {
      fill: $white;
    }
  }

  .pending-message {
    color: $grey4;
    font-size: 18px;
    line-height: 1.5;
    margin: 0;
  }

  .btn.orange {
    background-color: $purple;
    border-color: $purple;
    color: $white;

    &:hover:not(:disabled) {
      background-color: transparent;
      border-color: $purple;
      color: $grey4;
    }

    &:focus,
    &:active {
      border-color: $purple !important;
      color: $grey4 !important;
    }
  }
}
</style>
